export default {
    register: "/register",
    login: "/login",
    resetPassword: "/reset-password",
    newPassword: "/new-password",
    newPasswordOffline: "/new-password-set",
    verifiedEmail: "/verified-email",
    expiredEmail: "/expired-email",
    offlineRegistrationSuccess: "/offline-registration-success",
    offlineRegistrationSuccessWithClubCard: "/offline-registration-success-with-club-card",
    smsPhoneValidation: "/verify-phone",
};
